module.exports = __webpack_public_path__ + "static/media/Direct_email_pad.1dea027d.png";